import { registerLocaleData } from '@angular/common';
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { ApplicationConfig, LOCALE_ID, provideZonelessChangeDetection } from '@angular/core';
import { provideRouter, withEnabledBlockingInitialNavigation, withInMemoryScrolling } from '@angular/router';
import localePt from '@angular/common/locales/pt';
import Aura from '@primeuix/themes/aura';
import { providePrimeNG } from 'primeng/config';
import { appRoutes } from './app.routes';
import { definePreset } from '@primeuix/themes';
import { authInterceptor } from './app/core/interceptors/auth.interceptor';
import { provideTranslateService } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { provideApiConfiguration } from './app/core/api/api-configuration';
import { provideAppTranslations } from './app/core/i18n/provide-app-translations';
import { environment } from './environments/environment';

registerLocaleData(localePt, 'pt-BR');

const primeNgPt = {
    firstDayOfWeek: 0,
    dayNames: ['Domingo', 'Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado'],
    dayNamesShort: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'],
    dayNamesMin: ['D', 'S', 'T', 'Q', 'Q', 'S', 'S'],
    monthNames: ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'],
    monthNamesShort: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'],
    today: 'Hoje',
    clear: 'Limpar'
};

const MyPreset = definePreset(Aura, {
    semantic: {
        primary: {
            50: '{blue.50}',
            100: '{blue.100}',
            200: '{blue.200}',
            300: '{blue.300}',
            400: '{blue.400}',
            500: '{blue.500}',
            600: '{blue.600}',
            700: '{blue.700}',
            800: '{blue.800}',
            900: '{blue.900}',
            950: '{blue.950}'
        } as never
    },
    components: {
        // Clearer zebra contrast than Aura defaults (Refactoring UI):
        // alternate rows should aid scanning without overpowering content.
        datatable: {
            row: {
                background: 'light-dark({content.background}, {surface.800})',
                hoverBackground: 'light-dark({content.hover.background}, {surface.700})',
                stripedBackground: 'light-dark({surface.50}, {surface.950})'
            }
        }
    }
});

export const appConfig: ApplicationConfig = {
    /* v8 ignore start */
    providers: [
    /* v8 ignore stop */
        { provide: LOCALE_ID, useValue: 'pt-BR' },
        provideRouter(appRoutes, withInMemoryScrolling({ anchorScrolling: 'enabled', scrollPositionRestoration: 'enabled' }), withEnabledBlockingInitialNavigation()),
        provideHttpClient(withFetch(), withInterceptors([authInterceptor])),
        provideApiConfiguration(environment.apiUrl),
        provideZonelessChangeDetection(),
        providePrimeNG({
            translation: primeNgPt,
            theme: { preset: MyPreset, options: { darkModeSelector: '.app-dark' } },
            license:
                'eyJpZCI6IjhmOTZjYjM0LWJiMmItNDA2NC05ZmFhLTllMWQ1NGRkMmE5YiIsInByb2R1Y3QiOiJwcmltZXVpIiwidGllciI6ImNvbW11bml0eSIsInR5cGUiOiJkZXYiLCJpYXQiOjE3ODQ4MjczNjksImV4cCI6MTgxNjM2MzM2OX0.uaU0sDKG0SiX-lkgj1UaD0O4i2i3rCq2cntyZOfVOg6BZytIAmLi7mnoz25kNFP0G77xVwo-6zVPQA7YToNtDQ'
        }),
        provideTranslateService(),
        provideTranslateHttpLoader({ prefix: './i18n/', suffix: '.json', failOnError: true }),
        provideAppTranslations()
    ]
};
